import React, { useEffect, useState } from 'react';
import Select from "react-select";
import "./FactorKolDown.scss";
import NewTabulator from "../../NewTabulator/NewTabulator";

const FactorKolDown = (props) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);

  const handleChange = (selected) => {
    setSelectedOption(selected);
  };



  const columns = [
    { title: "کد برنامه", field: "ClassCode" },
    { title: "روز کلاس", field: "Classفitle" },
    { title: "شروع", field: "Classفitle" },
    { title: "پایان", field: "Classفitle" },
  ];

  useEffect(() => {
    // Filter options based on search text
    const filtered = props.options.filter((option) =>
      option.label.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredOptions(filtered);
  }, [searchText]);


  return (
    <div className='FactorKolDown'>
      <div className="searchBox__">
        <label>جستجو</label>
        <Select
          value={selectedOption}
          onChange={handleChange}
          options={filteredOptions}
          onInputChange={(inputValue) => setSearchText(inputValue)}
          isSearchable={true}
          placeholder='کد برنامه را وارد کنید'
        />
      </div>
      <div className='Table'>
        <NewTabulator
          columns={columns}
          // data={sendData.tableData} // Update data prop here
          style={{ height: "40vh", overflowY: "scroll" }}
          className={"header__color__F1F1F1"}
        />
      </div>
      <div className='btnsubmitandPrint'>
        <div className='btnsubmit'>
          <button type='submit'>ثبت و پرینت</button>
        </div>
        <div className='submit-btn'>
          <button id="submit-btn" type='submit'>ثبت</button>
        </div>
      </div>
    </div>
  );
};

export default FactorKolDown;
